import { Paths } from 'src/pages/paths';

const tenderDetailsPage = `${Paths.TENDER_ROUTE}${Paths.TENDER_PAGE}`; // Details page & custom report page

// Add to this list when other pages are made compatible!
// Tender free page is also "included" in this list but has to be handled separately.
// Auth routes are mobile compatible by default, no need to add them here
export const mobileCompatibleRoutes = [Paths.MONITORING, Paths.MONITORING_PAGE, tenderDetailsPage];
